import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useShowInsights from "./useShowInsights";
import InsightsServices from "../services/Insights.services";

function useLanguages() {
    const [language, setLanguage] = useState("");
    const [list, setList] = useState([]);

    const { country } = useSelector((state) => state.buildTargets.setup);
    const { mustShowInsights } = useShowInsights()
    useEffect(() => {
        if (mustShowInsights) {
            const tempList = InsightsServices.getLanguagesPerCountry();
            setLanguage(tempList[0] || "");
            setList(tempList);
        }
    }, [mustShowInsights, country]);

    return {
        value: language,
        setLanguage,
        list
    };
}

export default useLanguages;
